import { LineSeperator } from "../../../../components/RegularComponents";
import { InformationDetailPanelSection } from "../InformationDetailPanelSection";

export const FinancialStatementsTab = (props) => {
  const { appData } = props;

  return (
    <div>
      <InformationDetailPanelSection
        header={"Have the Financial Statements been submitted?"}
        value={appData?.isFinancialStatementSubmitted ? "Yes" : "No"}
      />
      <LineSeperator />
    </div>
  );
};
